var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerpinolene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#F58758;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.3,359h-9v-5.8h24.8v5.8H105v27.2h-6.6V359z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8H119V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.8,353.2h12.5c8,0,11.5,4.7,11.5,11c0,5-2.3,8.5-6.9,10l8.3,12.1h-7.8l-7.4-11.3h-3.8v11.3h-6.5V353.2z  M158,369.2c4,0,6-2,6-5.1c0-3.1-2-5.1-5.8-5.1h-5v10.1H158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.2,353.2h12.2c8,0,11.5,4.7,11.5,11c0,7.3-4.9,10.7-12.1,10.7h-5.1v11.3h-6.5V353.2z M188.1,369.2 c4.1,0,6-2,6-5.1c0-3.1-2-5.1-5.7-5.1h-4.7v10.1H188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.4,353.2h6.7v33h-6.7V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.4,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33h-6.6L227,364.4h-0.1v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.1,369.7c0-9.8,6.8-16.9,16.8-16.9c9.7,0,16.8,6.8,16.8,16.9c0,10-7.1,16.9-16.8,16.9 C260.9,386.6,254.1,379.5,254.1,369.7z M280.9,369.7c0-6.2-4.3-10.8-10-10.8c-6,0-10,4.8-10,10.8c0,6,4.1,10.8,10,10.8 C276.6,380.5,280.9,375.9,280.9,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.5,353.2h6.7v27.2h14.6v5.8h-21.3V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.8,353.2h21.1v5.8h-14.7v8H338v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.6,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33h-6.6l-14.7-21.8h-0.1v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.6,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,151h-4.8v43.9h5.4c2.4,0,3.6-2.3,3.6-7v-29.5c0-2.6-0.4-4.5-1.2-5.7C252,151.6,251,151,249.9,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.6,98.6c-54.4,0-98.6,44.1-98.6,98.6s44.1,98.6,98.6,98.6s98.6-44.1,98.6-98.6S302,98.6,247.6,98.6z  M224.6,151h-10v95.6h-10.1V151h-10v-8.5h30.1V151z M264.1,191c0,4.5-1.2,7.6-3.6,9.5c-2.4,1.8-5.4,2.8-9,2.8h-6.4v43.3H235V142.5 h15.9c3.6,0,6.7,1.2,9.3,3.7c2.6,2.4,3.9,6,3.9,10.8L264.1,191L264.1,191z M300.8,246.5h-24.1v-104H300v8.5h-13.3v39.7H297v7.6 h-10.3V238h14L300.8,246.5L300.8,246.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerpinolene);
export default __webpack_public_path__ + "static/media/TERPINOLENE.dbd0002672e88c00b2620167113f8178.svg";
export { ForwardRef as ReactComponent };